import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { SEC_606_REPORT_BASE_PATH } from '../../../../../../../../../features/trade-reporting/sec-606/trade-reporting-sec-606-report-routing';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/reporting/sec-606/_sec-606')({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'sec-606a-report-list',
        label: 'Reports',
        to: SEC_606_REPORT_BASE_PATH,
      }),
    }) satisfies AggregateBreadcrumb,
});
